<template>
    <sa-page-layout :btnBackVisible="false" :btnConfigurazioniVisible="true" :linkConfigurazioni="linkConfigurazioni" :linkback="linkback" :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem; margin-top: 0.5rem;">
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label">Voci Menu:</label>
                        <b-form-input v-model="filtroPazientiMenu.text" type="search" placeholder="Voci menu"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label">Application Reference</label>
                        <b-form-select v-model="filtroPazientiMenu.applicationReference" :options="applicationReferenceOptions"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label">Regime Reference:</label>
                        <b-form-input v-model="filtroPazientiMenu.regimeReference" type="search" placeholder="Regime reference"></b-form-input>
                    </b-col>
                </b-row>
                                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <configurazione-generale-pazienti-menu-list-component ref="ConfigurazioneGeneralePazientiMenuListComponent" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData"></configurazione-generale-pazienti-menu-list-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneGeneralePazientiMenuListComponent from "../components/ConfigurazioneGeneralePazientiMenuListComponent.vue";

export default {
    components: { SaPageLayout, ConfigurazioneGeneralePazientiMenuListComponent },
    data() {
        return {
            pathResource: "/rsapazientimenu",
            linkback: "/configurazionegenerale",
            linkConfigurazioni: "/configurazionegenerale",
            showModalLoading: false,
            listKey: 0,
            btnNewVisible: true,
            filtroPazientiMenu: { text: null, applicationReference: null, regimeReference: null },
            applicationReferenceOptions: [
                { text:"Tutti", value: null },
                { text:"APP", value: "APP" },
        ]
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage.getItem("filtroPazientiMenu")) {
            me.filtroPazientiMenu = JSON.parse(sessionStorage.getItem("filtroPazientiMenu"));
        }
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroPazientiMenu"] = JSON.stringify(me.filtroPazientiMenu);
            me.$refs.ConfigurazioneGeneralePazientiMenuListComponent.loadData(me.filtroPazientiMenu);
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroPazientiMenu"] = JSON.stringify(me.filtroPazientiMenu);
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroPazientiMenu = { text: null, applicationReference: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroPazientiMenu"] = JSON.stringify(me.filtroPazientiMenu);
            me.loadData();
        }
    },
};
</script>
